import { useEffect, useRef } from 'react'
import { api } from 'services'

const HEARTBEAT_INTERVAL_MS = 5 * 60 * 1000

const sendHeartbeat = () => api.get('client/heartbeat')

export default function useHeartbeat(enabled: boolean) {
  const enabledRef = useRef(enabled)
  enabledRef.current = enabled

  const lastSentAtRef = useRef(Date.now())
  const maybeSendHeartbeatRef = useRef<() => void>()

  maybeSendHeartbeatRef.current = () => {
    if (!enabledRef.current) return
    if (Date.now() - lastSentAtRef.current < HEARTBEAT_INTERVAL_MS) return

    lastSentAtRef.current = Date.now()
    sendHeartbeat()
  }

  useEffect(() => {
    const intervalId = setInterval(
      () => maybeSendHeartbeatRef.current?.(),
      HEARTBEAT_INTERVAL_MS,
    )
    return () => clearInterval(intervalId)
  }, [])

  useEffect(() => {
    if (enabled) {
      maybeSendHeartbeatRef.current?.()
    }
  }, [enabled])
}
